/**
 * A scrollbar that matches the surface it scrolls, not the browser's default
 * (dark grey/black, regardless of the page underneath). WebKit/Blink expose
 * this via pseudo-elements, which Tailwind reaches through an arbitrary
 * variant — every value referenced is still a real design token
 * (`hairline-alt`, `text-muted`, `rounded-pill`), nothing hardcoded.
 * Firefox has no pseudo-element hook for this and falls back to its own
 * default; not worth a second, hardcoded `scrollbar-color` just for that.
 */
export const THIN_SCROLLBAR =
  '[&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-pill [&::-webkit-scrollbar-thumb]:bg-hairline-alt [&::-webkit-scrollbar-thumb:hover]:bg-text-muted';
